import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2be97e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "banners" }
const _hoisted_4 = { class: "preview" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "play icon i-tool-play" }, null, -1))
const _hoisted_6 = { class: "name line1" }
const _hoisted_7 = { class: "time c-thirdary" }
const _hoisted_8 = { class: "view c-thirdary" }
const _hoisted_9 = {
  key: 0,
  class: "live orange"
}
const _hoisted_10 = {
  key: 1,
  class: "live red"
}
const _hoisted_11 = {
  key: 2,
  class: "live gray"
}
const _hoisted_12 = {
  key: 3,
  class: "live blue"
}
const _hoisted_13 = { class: "contents" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mask" }
const _hoisted_16 = { class: "name line1" }
const _hoisted_17 = { class: "time c-thirdary" }
const _hoisted_18 = {
  key: 0,
  class: "live orange"
}
const _hoisted_19 = {
  key: 1,
  class: "live red"
}
const _hoisted_20 = {
  key: 2,
  class: "live gray"
}
const _hoisted_21 = {
  key: 3,
  class: "live blue"
}
const _hoisted_22 = { class: "page-title" }
const _hoisted_23 = { class: "shorts" }
const _hoisted_24 = { class: "page-title" }
const _hoisted_25 = { class: "authors" }
const _hoisted_26 = { class: "name line1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon i-u466" })
], -1))
const _hoisted_28 = { class: "name line1" }

import Avatar from '@/views/components/Avatar.vue';
import home, { State } from '@/store/channels/home';
import i18, { State as I18State } from '@/store/i18';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';
import * as filters from '@/views/filters';
import ShortItem from '../ShortItem.vue'
import Request from '../Request.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const homeData = computed<State>(() => store.state[home.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].live)
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)
const temp = reactive({
    liveIndex: 0,
    requestVisible: false,
})
const currLive = computed(() => homeData.value.lives[temp.liveIndex])

function onRequest() {
    temp.requestVisible = true
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_unref(channelLang).lives), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "current",
          style: _normalizeStyle(_unref(filters).bg(_unref(currLive).thumb)),
          to: `/lives/${_unref(currLive).id}/index.html`
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(currLive).title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(filters).datetime(_unref(currLive).starttime)), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(lang).live_viewCount) + "：" + _toDisplayString(_unref(currLive).hits), 1),
            (_unref(currLive).push_status == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(lang).live_wait), 1))
              : _createCommentVNode("", true),
            (_unref(currLive).push_status == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(lang).live_play), 1))
              : _createCommentVNode("", true),
            (_unref(currLive).push_status == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(lang).live_end), 1))
              : _createCommentVNode("", true),
            (_unref(currLive).push_status == 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(lang).live_replay), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style", "to"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeData).lives, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["item", { on: i == _unref(temp).liveIndex }]),
            style: _normalizeStyle(_unref(filters).bg(item.thumb)),
            onClick: ($event: any) => (_unref(temp).liveIndex = i)
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(filters).datetime(item.starttime)), 1),
              (item.push_status == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(lang).live_wait), 1))
                : _createCommentVNode("", true),
              (item.push_status == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(lang).live_play), 1))
                : _createCommentVNode("", true),
              (item.push_status == 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(lang).live_end), 1))
                : _createCommentVNode("", true),
              (item.push_status == 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(lang).live_replay), 1))
                : _createCommentVNode("", true)
            ])
          ], 14, _hoisted_14))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("b", null, _toDisplayString(_unref(channelLang).shorts), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeData).shortTags, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "tag",
          to: `/shorts/index.html?tag=${item.tag}`
        }, {
          default: _withCtx(() => [
            _createTextVNode("#" + _toDisplayString(item.tag) + "#", 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_23, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeData).shortVideos, (item) => {
        return (_openBlock(), _createBlock(ShortItem, { item: item }, null, 8, ["item"]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("b", null, _toDisplayString(_unref(channelLang).channels), 1)
    ]),
    _createElementVNode("div", _hoisted_25, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeData).channels, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "item",
          to: `/channels/detail/${item.id}.html`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "avatar",
              style: _normalizeStyle(_unref(filters).bg(item.thumb))
            }, null, 4),
            _createElementVNode("div", _hoisted_26, _toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256)),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/channels/all.html"
      }, {
        default: _withCtx(() => [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(channelLang).allChannels), 1)
        ]),
        _: 1
      })
    ]),
    (_unref(temp).requestVisible)
      ? (_openBlock(), _createBlock(Request, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(temp).requestVisible = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})